/*
 * sca Actions
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 20-Jan-2025
 */

import { createRequestTypes, createAction, MakeRequest } from './index'

export const actionTypes = {
  DO_SAVE_ACTION_TYPE_AND_PAYLOAD: '@@sca/do_save_action_type_and_payload',
  DO_SAVE_TRACK_REQUEST_ACTION: '@@sca/do_save_track_request_action',
  DO_RESET_STATE: '@@sca/do_reset_state',
  DO_VERIFY_OTP: '@@sca/do_verify_otp',
  DO_REGENERATE_OTP: '@@sca/do_regenerate_otp',
  DO_SAVE_ERROR: '@@sca/do_save_error',
  DO_GENERATE_OTP: '@@sca/do_generate_otp',
  DO_SAVE_PERSISTENT_DATA: '@@sca/do_save_persistent_data',
  DO_RESET_SCA_ERROR: '@@sca/do_reset_sca_error',
  DO_CHECK_OTP_AML: '@@sca/do_check_otp_aml',
  DO_GENERATE_DOUBLE_OTP: '@@sca/do_generate_double_otp',
  DO_SAVE_OTP_TYPE: '@@sca/do_save_otp_type',
  // @generator action:type
  ...createRequestTypes('@@sca', 'GENERATE_OTP'),
  ...createRequestTypes('@@sca', 'CHECK_OTP_AML'),
  ...createRequestTypes('@@sca', 'GENERATE_DOUBLE_OTP')
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------

/** @action request
 * * Insert a description
 * @name generateOTP
 * @return {object} - The action object
 */
export const generateOTP = new MakeRequest('sca', 'generate_otp')
/** @action request
 * * Insert a description
 * @name checkOtpAml
 * @return {object} - The action object
 */
export const checkOtpAml = new MakeRequest('sca', 'check_otp_aml')
/** @action request
 * * Insert a description
 * @name generateDoubleOtp
 * @return {object} - The action object
 */
export const generateDoubleOtp = new MakeRequest('sca', 'generate_double_otp')
// @generator action:request

/** @action
 * * Insert a description
 * @name SaveActionTypeAndPayload
 * @return {object} - The payload object
 */
export const doSaveActionTypeAndPayload = (actionToInvoke, actionPayload) =>
  createAction(actionTypes.DO_SAVE_ACTION_TYPE_AND_PAYLOAD, { actionToInvoke, actionPayload })
/** @action
 * * Insert a description
 * @name SaveTrackRequestAction
 * @return {object} - The payload object
 */
export const doSaveTrackRequestAction = (payload) =>
  createAction(actionTypes.DO_SAVE_TRACK_REQUEST_ACTION, { payload })
/** @action
 * * Insert a description
 * @name ResetState
 * @return {object} - The payload object
 */
export const doResetState = () => createAction(actionTypes.DO_RESET_STATE, {})
/** @action
 * * Insert a description
 * @name RegenerateOtp
 * @return {object} - The payload object
 */
export const doRegenerateOtp = (payload) => createAction(actionTypes.DO_REGENERATE_OTP, { payload })
/** @action
 * * Insert a description
 * @name VerifyOtp
 * @return {object} - The payload object
 */
export const doVerifyOtp = (payload) => createAction(actionTypes.DO_VERIFY_OTP, { payload })
/** @action
 * * Insert a description
 * @name VerifyOtp
 * @return {object} - The payload object
 */
export const doSaveError = (payload) => createAction(actionTypes.DO_SAVE_ERROR, { payload })
/** @action
 * * Insert a description
 * @name GenerateOtp
 * @return {object} - The payload object
 */
export const doGenerateOtp = (payload) => createAction(actionTypes.DO_GENERATE_OTP, { payload })
/** @action
 * * Insert a description
 * @name SavePersistentData
 * @return {object} - The payload object
 */
export const doSavePersistentData = (payload) => createAction(actionTypes.DO_SAVE_PERSISTENT_DATA, { payload })
/** @action
 * * Insert a description
 * @name ResetScaError
 * @return {object} - The payload object
 */
export const doResetScaError = (payload) => createAction(actionTypes.DO_RESET_SCA_ERROR, { payload })
/** @action
* * Insert a description
* @name doCheckOtp
* @return {object} - The payload object
*/
export const doCheckOtpAml = payload => createAction(actionTypes.DO_CHECK_OTP_AML, { payload, isSca: true })
/** @action
* * Insert a description
* @name doGenerateDoubleOtp
* @return {object} - The payload object
*/
export const doGenerateDoubleOtp = payload => createAction(actionTypes.DO_GENERATE_DOUBLE_OTP, { payload })
/** @action
* * Insert a description
* @name doSaveOtpType
* @return {object} - The payload object
*/
export const doSaveOtpType = (otpType) => createAction(actionTypes.DO_SAVE_OTP_TYPE, { otpType })
// @generator action
